import { Badge, Col, Row } from 'react-bootstrap';
import { LuCalendarDays, LuBellDot } from 'react-icons/lu';
import { GoPerson } from 'react-icons/go';
import ViewOffSlashIcon from '@components/Icons/ViewOffSlash/ViewOffSlash';
import TwoPersonIcon from '@components/Icons/TwoPerson/TwoPerson';
import IJobDetail, { JobMember } from '@th-types/job.detail.type';
import { IJobStats } from '@th-types/jobs.type';
import DATE_FORMATS from '@constants/dateFormat';
import { formatLocalDate, UTC_TIMEZONE } from '@utils/DateUtils';
import { BASE_PATH } from '@utils/Environment';
import {
  getAddressLink,
  getFilledPosition,
  getTotalHiddenApplicants,
  SMALL_ICONS_SIZE,
} from '@utils/JobUtils';

import '../style.scss';
import { Link } from 'react-router-dom';

interface Props {
  job: IJobDetail;
  jobStats?: IJobStats;
  showJobMembers?: (members: JobMember[]) => void;
}

export default function JobShiftsHeaderMobile({
  job,
  jobStats,
  showJobMembers,
}: Props) {
  if (!jobStats) {
    return null;
  }

  return (
    <div className="job-shifts-mobile-header mt-2">
      <Row className="ps-2">
        <Link
          className="item-links fs-6 text-capitalize fw-bold"
          target="_blank"
          to={`${BASE_PATH}jobs/${job.id}`}
        >
          {job.eventName}
          {!job.datePublished && (
            <Badge className="ms-2" bg="secondary" text="dark">
              Draft
            </Badge>
          )}
        </Link>
      </Row>
      <Row className="ps-2 mt-2">
        <span>
          {job.title.name} at <strong>{job.brandRepresented}</strong>
        </span>
      </Row>
      <Row className="ps-2 my-1">
        <span className="item-info">
          {getAddressLink(job.nationalJob, job.address)}
        </span>
      </Row>
      <Row className="ps-2 my-1">
        <Col xs={6}>
          <LuCalendarDays size={SMALL_ICONS_SIZE} className="mb-1 me-1" />
          <span>
            {formatLocalDate(
              job.localizedStart,
              DATE_FORMATS.DATE_FORMAT_SHORT,
              UTC_TIMEZONE
            )}{' '}
            -{' '}
            {job.localizedEnd
              ? formatLocalDate(
                  job.localizedEnd,
                  DATE_FORMATS.DATE_FORMAT_SHORT,
                  UTC_TIMEZONE
                )
              : 'on going'}
          </span>
        </Col>
        <Col
          xs={6}
          data-testid="internal-members-col"
          onClick={() => {
            const jobMembers = job.members?.filter((item) => item.isInternal);
            if (jobMembers && showJobMembers) {
              showJobMembers(jobMembers);
            }
          }}
          className={`text-start ps-0 ${job.members?.length > 0 ? 'cursor-point' : ''}`}
        >
          <GoPerson size={SMALL_ICONS_SIZE} className="mb-1 me-1" />
          <span>
            Internal:{' '}
            {job.members?.filter((item) => item.isInternal).length || 0}
          </span>
        </Col>
      </Row>
      <Row className="ps-2 my-1">
        <Col xs={6}>
          <TwoPersonIcon size={SMALL_ICONS_SIZE} className="mb-1 me-1" />
          <span>Hired: {getFilledPosition(job, jobStats)}</span>
        </Col>
        <Col xs={6} className="text-start ps-0">
          <LuBellDot className="me-1" />
          <span>New Applicants: {jobStats.countNewApplicants}</span>
        </Col>
      </Row>
      <Row className="ps-2 my-1">
        <div>
          <ViewOffSlashIcon size={SMALL_ICONS_SIZE} className="mb-1" />
          <span className="ps-1">
            Hidden: {getTotalHiddenApplicants(jobStats)}
          </span>
        </div>
      </Row>
    </div>
  );
}
